export const blockIconsSocialEmojiEvents = (
	<span className='material-symbols-outlined'>emoji_events</span>
);
